module.exports = __webpack_public_path__ + "static/media/23-10.1f41221e.mp3";